export default "__VITE_ASSET__DIaVhFvm__"